module.exports = __webpack_public_path__ + "static/img/Fox-Jess.dc55f63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Fox-Jess.jpg
// module id = wO6b
// module chunks = 1